import { makeStyles, tokens } from '@fluentui/react-components';

export const usePolicyViewerStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        width: '100%',
        minWidth: 0,
    },
    card: {
        boxSizing: 'border-box',
        backgroundColor: tokens.colorNeutralBackground1,
        borderRadius: tokens.borderRadiusLarge,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        minWidth: 0,
    },
    headerCard: {
        display: 'flex',
        alignItems: 'flex-start',
        padding: '16px 20px',
    },
    headerMain: {
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr)',
        alignItems: 'center',
        columnGap: '16px',
        minWidth: 0,
    },
    headerText: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        minWidth: 0,
    },
    title: {
        margin: 0,
        fontFamily: `'Segoe UI', ${tokens.fontFamilyBase}`,
        fontSize: '20px',
        lineHeight: '100%',
        fontWeight: 700,
        letterSpacing: '0',
        color: tokens.colorNeutralForeground1,
        overflowWrap: 'anywhere',
    },
    subtle: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground3,
        overflowWrap: 'anywhere',
    },
    typeBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
        minWidth: '56px',
        height: '32px',
        padding: '0 12px',
        borderRadius: tokens.borderRadiusMedium,
        fontFamily: `'Segoe UI', ${tokens.fontFamilyBase}`,
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '100%',
        letterSpacing: '0',
    },
    typeBadgeHtml: {
        backgroundColor: tokens.colorPaletteGreenBackground1,
        color: tokens.colorPaletteGreenForeground1,
    },
    typeBadgePdf: {
        backgroundColor: tokens.colorPaletteRedBackground1,
        color: tokens.colorPaletteRedForeground1,
    },
    viewerCard: {
        boxSizing: 'border-box',
        overflow: 'hidden',
        backgroundColor: tokens.colorNeutralBackground3,
        borderRadius: tokens.borderRadiusLarge,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        minWidth: 0,
    },
    frame: {
        display: 'block',
        width: '100%',
        height: '72vh',
        minHeight: '520px',
        border: 'none',
        backgroundColor: tokens.colorNeutralBackground1,
    },
    stateBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        padding: '64px 20px',
        textAlign: 'center',
        color: tokens.colorNeutralForeground3,
    },
});
